import { render, staticRenderFns } from "./templates-settings.vue?vue&type=template&id=4b9d4b78&scoped=true"
import script from "./templates-settings.vue?vue&type=script&lang=js"
export * from "./templates-settings.vue?vue&type=script&lang=js"
import style0 from "./templates-settings.vue?vue&type=style&index=0&id=4b9d4b78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b9d4b78",
  null
  
)

export default component.exports